<div style="width: 100%; display:flex; justify-content: center;">

<div class="content" style="width: 900px;">
  <router-outlet></router-outlet>
</div>
</div>
